import React, { useEffect } from 'react';
import {
  RestaurantDetails_getRestaurantDetails,
  RestaurantDetails_getRestaurantDetails_reviews
} from '../../../../../types/graphql-types-generated.ts';
import { Button } from '../../../../../patterns/00-atoms/button/button.tsx';
import { FiveStarRating } from '../../00-atoms/five-star-rating/five-star-rating.tsx';
import { Paths } from '../../../../../utils/paths.ts';
import { prgLink } from '../../../../../utils/prg-resolver.ts';
import { UBTracking } from '../../../../../components/tracking/ubtracking.ts';

export type RestaurantInfoModalReviewsProps = {
  restaurantDetails: RestaurantDetails_getRestaurantDetails;
};

export const RestaurantInfoModalReviews: React.FunctionComponent<
  RestaurantInfoModalReviewsProps
> = props => {
  const writeReviewButtonRef = React.useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (writeReviewButtonRef.current) {
      UBTracking.onTrackTargetView(
        writeReviewButtonRef.current,
        'restaurant_info_modal',
        'write_review'
      );
    }
  });

  return (
    <div className="text-sm">
      <h2 className="mt-3 text-xl font-extrabold">Bewertungen</h2>
      <div className="mt-2 flex items-center">
        <span className="text-sk-link-red text-2xl/6">
          <FiveStarRating rating={props.restaurantDetails.averageReviewScore} />
        </span>
        <span className="ml-2 font-bold">
          Ø {props.restaurantDetails.averageReviewScore.toFixed(1)}
        </span>
        <span className="ml-1">({props.restaurantDetails.reviewsCount} Bewertungen)</span>
      </div>
      <div className="mt-2">
        <span className="font-bold">
          Nr. {props.restaurantDetails.rankingScore.rankingInCity} von{' '}
          {props.restaurantDetails.rankingScore.totalRestaurantsInCity}
        </span>
        <span className="ml-1 font-medium">in</span>
        <a
          className="text-sk-link-red ml-1 font-medium"
          href={Paths.cityListing(props.restaurantDetails.linkedCity.fullnameLower)}
        >
          Restaurants in {props.restaurantDetails.linkedCity.name}
        </a>
      </div>
      <div className="mt-4">
        <Button
          ref={writeReviewButtonRef}
          className="w-full text-center"
          onClick={() => {
            UBTracking.trackEvent.click('restaurant_info_modal', 'write_review');
            prgLink(
              Paths.restaurantReview(
                props.restaurantDetails.linkedCity.fullnameLower,
                props.restaurantDetails.keyname
              )
            );
          }}
        >
          Eigene Bewertung schreiben
        </Button>
      </div>
      <div>
        {props.restaurantDetails.reviews?.map((review, index) => (
          <RestaurantReview review={review} key={index} />
        ))}
      </div>
    </div>
  );
};

// TODO: filter by "online"?!
const RestaurantReview: React.FunctionComponent<{
  review: RestaurantDetails_getRestaurantDetails_reviews;
}> = props => {
  return (
    props.review.online && (
      <div className="border-sk-grey-200 mt-4 border-t-1 pt-4">
        <div className="text-2xl">
          <FiveStarRating rating={props.review.score} />
        </div>
        {(props.review.externalUserName && (
          <div className="font-bold">{props.review.externalUserName}</div>
        )) || <div className="font-bold">{props.review.user?.username}</div>}
        <div>
          {props.review.published && new Date(props.review.published).toLocaleDateString()}
          &nbsp;
          {props.review.externalUri && (
            <a href={props.review.externalUri} className="text-sk-red-500">
              {props.review.sourceName}
            </a>
          )}
        </div>
        <p className="mt-2">{props.review.comment}</p>
      </div>
    )
  );
};
